import Service, { serviceSelector, useService } from 'react-reservice';

interface IServiceContext {}

export const pickProperties = <T, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> => {
  const newObj: Pick<T, K> = {} as Pick<T, K>;

  keys.forEach((key) => {
    const objProp = obj[key];

    if (objProp !== undefined) {
      newObj[key] = objProp;
    }
  });

  return newObj;
};

export const omitProperties = <T, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> => {
  const newObj = { ...obj };

  keys.forEach((key) => {
    delete newObj[key];
  });

  return newObj;
};

export const getUseServiceWithSubscriptionKeys = <T extends IServiceContext>(service: Service<T>) => (
  subscriptionKeys: (keyof T)[]
) => useService(service, serviceSelector<typeof service, T>(subscriptionKeys));
